module.exports = __webpack_public_path__ + "img/13bd2bd.png";